export const signInUrl = "api/authenticate"; //"signin.php";
export const signUpUrl = "api/register";
export const googleSignup = "/api/oauth2/register-google-oauth2";
export const azureSignup = "/api/oauth2/register-azure-oauth2";
export const activateAccountUrl = "api/validate-otp";
export const validateUser = "api/validate-user";
export const resendEmailUrl = "api/resend-otp";
export const refreshTokenUrl = "/api/authenticate/refresh";
export const logoutUrl = "api/invalidate-session";
export const changeEmailUrl = "api/account/change-email";
export const industryApiUrl = "api/industries";
export const employeeCountApiUrl = "api/employee-ranges";
export const companyTypeApiUrl = "api/companycategories";
export const revenueRangeApiUrl = "api/company-revenue-ranges";
export const companyListingApiUrl = "api/companies";
export const companyExlDownloadUrl = "api/employees/exl";
export const companyPdfDownloadUrl = "api/companies/pdf";
export const employeeListUrl = "api/employees";
export const executiveDepartmentList = "api/executive-functions";
export const clientLeadsUrl = "/api/client-leads";
export const errorReport = "/api/incorrect-data-reporteds";
export const saveSearch = "/api/externaldatadumps";
export const sigleCompanyTag = "/api/company-tags";
export const accountInfoApiUrl = "/api/account";
export const fetchCompanyTagApiUrl = "/api/company-tags";
export const saveSearchListApiUrl = "/api/externaldatadumps";
export const getCompanyTagApiUrl = "/api/company-tags/uniqueList/";
export const postRelavantCompanyApiUrl = "/api/user-prefered-records";
export const getRelavantCompanyApiUrl = "/api/user-prefered-records";
export const getClientLeadsUrl = "/api/client-leads";
export const createBatchClientLeads = "/api/client-leads-batch";
export const getClientLeadsKanbanUrl = "/api/client-leads/Kanban";
export const groupCompanyTagUrl = "/api/company-tags/multi";
export const executiveEmployeeListingApiUrl = "/api/employees";
export const getExecutiveTagApiUrl = "/api/employee-tags/uniqueList/";
export const getExecutiveFunctionApiUrl = "/api/executive-functions";
export const getExecutiveLevelApiUrl = "/api/executive-levels";
export const groupExecutiveTagUrl = "/api/employee-tags/multi";
export const subscriptionaccountInfoApiUrl = "/api/subscriptions/";
export const leadConversionUrl = "/api/client-leads/employee";

export const createLeadTags = "/api/lead-tags/multi";
export const allTags = "/api/tags";

export const fetchExecutiveTagApiUrl = "api/employee-tags";
export const saveClientNoteApiUrl = "api/client-notes";
export const getClientNotesApiUrl = "api/client-notes";
export const getClientRemarksApiUrl = "api/client-remarks";
export const getLeadStatusApiUrl = "api/statusforkanban";
export const getLeadRatingApiUrl = "api/lead-rating";
export const getLeadTasksStatusApiUrl = "api/statusfortasks";

export const getDashboardClosedOpportunityApiUrl = "api/dashBoard-top5Closed";
export const getDashboardOpenOpportunityApiUrl = "api/dashBoard-top5Open";
export const getDashboardGroupedCountApiUrl = "api/grouped-count";
export const getDashboardSalesTrendApiUrl = "api/grouped-salestrendz";
export const getDashboardGroupedBySourceApiUrl = "api/grouped-bysource";
export const getDashboardGroupedByIndustryApiUrl = "api/grouped-byindustry";
export const getDashboardGroupedByActivityApiUrl =
  "api/dashboard-groupcountOnactivity";
export const getDashboardGroupedByActivityStatusApiUrl =
  "api/getLeadCountByGroupedColumnOnActivityStatus";
export const getDashboardGroupedByCallActivityApiUrl =
  "api/dashboard-groupMostCallTop5";
export const getDashboardGroupedByMeetingActivityApiUrl =
  "api/dashboard-groupMostMeetTop5";
export const getDashboardGroupedByEmailActivityApiUrl =
  "api/dashboard-groupMostEmailTop5";

export const getDashboardConvertedLeadsApiUrl =
  "api/dashBoard-top5ConvertedLeads";
export const getDashboardRecomendationCompanyApiUrl =
  "api/recomendation/company";
export const getDashboardRecomendationEmployeeApiUrl =
  "/api/recomendation/employee";

export const companySelectionApiUrl = "/api/companies/selection";
export const employeeSelectionApiUrl = "/api/employees/selection";
export const mailerApiUrl = "/api/mailers";
export const ussageApiUrl = "/api/ussage-details";
export const changePasswordApiUrl = "api/account/change-password";
export const ussageLeadCountApiUrl = "/api/client-leads/count";
export const forgotPasswordApiUrl = "api/account/reset-password/init";
export const resetPasswordApiUrl = "api/account/reset-password/finish";
export const webToLead = "/api/web-to-leads-configurations";
export const leadCustomFieldDefinitions = "/api/lead-custom-field-definitions";
export const oauth2Google = "/api/oauth2/google-connect";
export const authenticateOutlookApiUrl = "/api/oauth2/azure-connect";
export const googleAuthorize = "/api/oauth2/google-authorize";
export const outlookAuthorize = "/api/oauth2/azure-authorize";
export const emailConfiguration = "/api/email-configuration";
export const sendMailUrl = "api/send-mail";
export const emailConversationHistory = "/api/email-conversation-history";

export const connectToAzureForSignup = "/api/oauth2/azure-signup-connect";
export const connectToAzureForSignin = "/api/oauth2/azure-signin-connect";
export const authorizeToAzureForSignup = "/api/oauth2/azure-signup-authorize";
export const authorizeToAzureForSignin = "/api/oauth2/azure-signin-authorize";

export const connectToGmailForSignup = "/api/oauth2/google-signup-connect";
export const connectToGmailForSignin = "/api/oauth2/google-signin-connect";
export const authorizeToGmailForSignup = "/api/oauth2/google-signup-authorize";
export const authorizeToGmailForSignin = "/api/oauth2/google-signin-authorize";
export const receiveEmailUrl = "/api/receive-mail";
export const markAsReadUrl = "/api/mark-mails-as-read";

export const connectToGoogleForRM =
  "/api/oauth2/google-reputation-manager-connect";
export const authorizeToGoogleForRM =
  "/api/oauth2/google-reputation-manager-authorize";
export const reviewsConfiguration =
  "/api/oauth2/reputation-manager-configuration";
export const reviewsListingUrl = "/api/reviews";

export const usersActionsUrl = "/api/managed-users";
export const userBulkActionUrl = "/api/users/bulk-action";

export const accountRoles = "/api/account-roles";

export const accountTeams = "/api/account-teams";
export const teamUsers = "/api/user-teams";

export const employeeTag = "/api/employee-tags";
export const companyTag = "/api/company-tags";
export const leadTag = "/api/lead-tags";
export const unqualifiedReasons = "/api/unqualified-reasons";
export const subscriptionPackages = "/api/subscription-packages";
export const pricingCalculate = "/api/public/pricing/calculate";
export const billingDetails = "/api/billing-details";
export const createPayment = "/api/create-invoices";
export const verifyPayment = "/api/verify-payments";
export const paymentsHistory = "/api/payments";

export const csvImportUrl = "api/client-leads/import/csv-xlsx-connect";
export const importPreview = "/api/client-leads/import/preview";
export const importSummary = "/api/client-leads/import/summary";

export const googleImportConnect =
  "/api/client-leads/import/gmail/contacts-connect";
export const googleImportAuthorize = "/api/client-leads/gmail-import-authorize";
export const googleImportDisconnect =
  "/api/client-leads/import/gmail-disconnect";
export const googleLatestSync = "/api/client-leads/import/gmail/sync";

export const csvDisconnect = "/api/client-leads/import/csv-xlsx-disconnect";
export const importToLead = "/api/client-leads/import/client-leads";

export const leadImportEmployees =
  "/api/employees/lead-imported-contacts/import";
export const disconnectBeyonData =
  "/api/client-leads/import/beyondleadz-data-disconnect";

export const outlookImportConnect =
  "/api/client-leads/import/outlook/contacts-connect";
export const outlookImportAuthorize =
  "/api/client-leads/outlook-import-authorize";
export const outlookImportDisconnect =
  "/api/client-leads/import/outlook-disconnect";
export const outlookLatestSync = "/api/client-leads/import/outlook/sync";

export const calendarEvents = "/api/calendar-events";
export const calendarEventTypes = "/api/calendar-event-types";
export const meetingTypes = "/api/meeting-types";
export const availabilitySlots = "/api/availability-slots";
export const availabilityTimezone = "/api/availability-slots/timezone";
export const notificationSettings = "/api/notification-settings";
export const calenderConnect = "/api/calendar/connect";
export const calendarAuthorize = "/api/calendar/oauth-callback";
export const calenderSync = "/api/calendar/sync-up";
export const calenderDisconnect = "/api/calendar/disconnect";
export const calendarIntegrationSummary = "/api/calendar/connection-summary";

export const genAIGenerate = "/genai-api/generate/email";
export const genAIWebsocket = "genai-api/ws";
export const genAIsession = "/genai-api/chat/session";
export const genAIEmailTemplates = "/genai-api/email/templates";
export const genAIChat = "/genai-api/chat";

export const notifications = "/api/notifications";

export const publicMeetingLinks = "/api/public-meeting-links";
export const publicBooking = "/api/public/booking";

export const audienceApiUrl = "api/campaign-audiences";
export const importApiUrl = "api/imports";
